import {
  jb_video_icon_css_default
} from "./chunk.3ABODVVS.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Icon
} from "./chunk.RCJUEYAG.js";
import {
  D,
  Oe,
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  n
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/icons/jb-video-icon/jb-video-icon.ts
var JbVideoIcon = class extends Icon(r) {
  constructor() {
    super(...arguments);
    this.circle = Oe`<circle cx="13" cy="13" r="12.5"/>`;
    this.withCircle = false;
  }
  render() {
    return ke` <svg
      width="26"
      height="26"
      viewbox="0 0 26 26"
      xmlns="http://www.w3.org/2000/svg"
    >
      ${this.withCircle ? this.circle : D}
      <path d="M10 19V7l10 6z" />
    </svg>`;
  }
};
JbVideoIcon.styles = [reset_css_default, jb_video_icon_css_default];
__decorateClass([
  n({ type: Boolean })
], JbVideoIcon.prototype, "withCircle", 2);
JbVideoIcon = __decorateClass([
  customElement("jb-video-icon")
], JbVideoIcon);

export {
  JbVideoIcon
};
